import { render, staticRenderFns } from "./MpData.vue?vue&type=template&id=584288c8&scoped=true&"
import script from "./MpData.vue?vue&type=script&lang=js&"
export * from "./MpData.vue?vue&type=script&lang=js&"
import style0 from "./MpData.vue?vue&type=style&index=0&id=584288c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584288c8",
  null
  
)

export default component.exports